import { useState } from "react";
import { useTranslation } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import { EInvoiceListTab } from "./components/eInvoiceListTab";
import { EInvoiceSePayConfigTab } from "./components/eInvoiceSePayConfigTab";

const TABS = {
  LIST: "list",
  CONFIG: "config",
} as const;

const WPSEInvoicesPage: React.FC = () => {
  const { translate } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>(TABS.LIST);

  const breadcrumbItems = [
    {
      label: translate("menu-einvoices"),
      href: "/organization/einvoice",
    },
  ];

  return (
    <div className="wrapper">
      <Breadcrumbs type="wps" breadcrumbItems={breadcrumbItems} />
      <div className="w-full p-4">
        <div className="flex border-b border-gray-200 mb-4">
          <button
            className={`px-4 py-2 text-sm font-semibold border-b-2 transition-colors ${
              activeTab === TABS.LIST
                ? "border-brand-500 text-brand-500"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
            onClick={() => setActiveTab(TABS.LIST)}
          >
            {translate("einvoice-list")}
          </button>
          <button
            className={`px-4 py-2 text-sm font-semibold border-b-2 transition-colors ${
              activeTab === TABS.CONFIG
                ? "border-brand-500 text-brand-500"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
            onClick={() => setActiveTab(TABS.CONFIG)}
          >
            {translate("einvoice-sepay-config")}
          </button>
        </div>

        {activeTab === TABS.LIST && <EInvoiceListTab />}
        {activeTab === TABS.CONFIG && <EInvoiceSePayConfigTab />}
      </div>
    </div>
  );
};

export default WPSEInvoicesPage;
